/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import PropTypes from "prop-types"
import React from "react"
import Layout from "./layout"
import formatDistanceToNow from "date-fns/formatDistanceToNow"
import SEO from "../components/seo"

const PostsLayout = ({ children, pageContext }) => {
  console.log(pageContext)
  return (
    <>
      <Layout>
        <SEO title={pageContext.frontmatter.title}></SEO>
        <h1
          style={{
            marginBottom: "0.3em",
          }}
        >
          {pageContext.frontmatter.title}
        </h1>
        <div
          style={{
            fontSize: "0.9em",
            lineHeight: "1.45em",
            marginBottom: "1.45em",
          }}
        >
          <span>Created by {pageContext.frontmatter.author}</span>,{" "}
          <span>
            Last updated{" "}
            {formatDistanceToNow(new Date(pageContext.frontmatter.last), {
              addSuffix: true,
            })}
          </span>
        </div>
        {children}
      </Layout>
    </>
  )
}

PostsLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PostsLayout
